module.exports = __webpack_public_path__ + "22d6b26efd2c219216c3f66fa019e4e4.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-back/sp-back.html
// module id = 982
// module chunks = 0